export default "__VITE_ASSET__CImGRvzM__"